import { login, LoginProps } from "@/services/login";
import {
  iamTokenManager,
  iamAccountManager,
  iamFirstLoginManager,
  iamEmailSessionIdManager,
  iamEmailManager,
  iamVerifyCodeManager,
  iamLoginMethodManager,
  iamInviteIamEmailManager,
  iamInviteIamTokenManager,
} from "@/manager";

export function useAPIEmailLogin() {
  const handleEmailLogin = async (code: string, agentId?: string) => {
    const props: LoginProps = {
      email: iamEmailManager.get(),
      loginMethod: 2,
      emailSessionId: iamEmailSessionIdManager.get(),
      emailVerification: code,
      agentId,
    };
    if (iamFirstLoginManager.get()) {
      props.name = iamEmailManager.get().split("@")[0];
    }
    // 登录邮箱和邀请邮箱是同一个则添加邀请凭证参数
    if (iamEmailManager.get() === iamInviteIamEmailManager.get()) {
      props.inviteToken = iamInviteIamTokenManager.get();
    }
    await handleLogin(props);
  };

  const handleInvitationLogin = async (rsaId: string, activationCode: string) => {
    const loginMethod = iamLoginMethodManager.get();
    const props: LoginProps = {
      // 走邀请码登录默认是第一次登录
      name: iamEmailManager.get().split("@")[0],
      email: iamEmailManager.get(),
      loginMethod,
      rsaId,
      activationCode,
    };
    if (loginMethod === 2) {
      props.emailSessionId = iamEmailSessionIdManager.get();
      props.emailVerification = iamVerifyCodeManager.get();
    } else {
      props.thridPartySessionId = iamEmailSessionIdManager.get();
    }
    // 登录邮箱和邀请邮箱是同一个则添加邀请凭证参数
    if (iamEmailManager.get() === iamInviteIamEmailManager.get()) {
      props.inviteToken = iamInviteIamTokenManager.get();
    }
    await handleLogin(props);
  };

  const handleLogin = async (props: LoginProps) => {
    const data = await login(props);
    if (data.token) {
      // 处理全局状态
      iamTokenManager.updateToken(data.token);
    }
  };

  return {
    handleEmailLogin,
    handleInvitationLogin,
    handleLogin,
  };
}
